<script lang="ts">
  const { size = '1em' }: { size?: string | number } = $props();
</script>
<svg width={size} height={size} 
   viewBox="0 0 24 24"
   fill="none"
   stroke="currentColor"
   stroke-width="2"
   stroke-linecap="round"
   stroke-linejoin="round"
   version="1.1"
   id="svg3"
   xmlns="http://www.w3.org/2000/svg"
>
  <path d="M 3,12 H 6" />
  <path
     d="M 3,6 H 5.8637927"
     style="stroke-width:2" />
  <path
     d="M 3,18 H 21" />
  <path
     class='help'
     style="color:currentColor;stroke:none"
     d="m 16,0 c -4.404731,-9.99999e-8 -8,3.5952678 -8,8 0,4.404733 3.595269,8 8,8 4.404736,0 8,-3.595267 8,-8 0,-4.4047322 -3.595264,-8 -8,-8 z m -0.06836,2 c 0.227466,3.077e-4 0.453843,0.0195 0.675781,0.058594 C 18.382379,2.3712458 20.0023,3.9369877 20,6.1738281 v 0.00195 c -9.71e-4,1.5426125 -1.078843,2.5852391 -1.978516,3.2011719 -0.900078,0.6162136 -1.785156,0.914063 -1.785156,0.914063 A 1,1 0 0 1 15,9.6679688 1,1 0 0 1 15.587891,8.3984375 c 0,0 0.659077,-0.2312126 1.302734,-0.671875 C 17.534282,7.2859001 18,6.7438211 18,6.1738281 a 1,1 0 0 0 0,0 C 18,4.8403032 17.199148,4.1944216 16.261719,4 15.32429,3.864172 14.374333,4.1889679 13.945312,5.4414062 A 1,1 0 0 1 12.675781,6.0625 1,1 0 0 1 12.054688,4.7929688 C 12.688558,2.9425107 14.33937,2 15.931641,2 Z M 16,12 h 0 a 1,1 0 0 1 1,1 1,1 0 0 1 -1,1 H 16 a 1,1 0 0 1 -1,-1 1,1 0 0 1 1,-1 z" />
</svg>
<style lang='scss'>
   @use '~/theme/theme.scss';
   .help {
      fill: theme.$star-penalty;
   }
</style>